import { useOutletContext } from "react-router-dom";

import EmailTemplatesPage from "layouts/LandPage/components/Layouts/Email/EmailTemplatePage";

// Thin route wrapper — renders the existing Email Templates screen with the
// websiteId from the WebsiteLayout outlet context.
function EmailTemplatesRoute() {
  const { websiteId } = useOutletContext();
  return <EmailTemplatesPage websiteId={websiteId} />;
}

export default EmailTemplatesRoute;
